// Server domain address

const config = {
  MAINTENANCE_PASSWORD: '$t@gEP@$$word',
  MAINTENANCE_TEXT: 'Stage is on Maintenance',
  URI: 'https://dev-lfv-api.workshop.tokyo',
  VIDEO_URL: 'https://video-dev.workshop-live.com',
  ADMIN_URL: 'https://admin-dev.workshop-live.com',
  STRIPE_KEY: 'pk_test_EW0Ik0y7VfUdL1JVn8vqWNBk',
  PLANS: {
    free: 'Free',
    free_admin: 'Free',
    free_guest: 'Free',
    guest: 'Free',
    starter_month: 'Starter monthly',
    starter_year: 'Starter yearly',
    premium_month: 'Premium monthly',
    premium_year: 'Premium yearly'
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyDsddDaw6PK6UO_Ht8m5Blq5uTrAHnPOO8',
    authDomain: 'workshop-video-prod.firebaseapp.com',
    databaseURL: 'https://workshop-video-prod.firebaseio.com',
    projectId: 'workshop-video-prod',
    storageBucket: 'workshop-video-prod.appspot.com',
    messagingSenderId: '447629060783'
  },
  S3: {
    bucketName: 'dev-roomrecordings',
    region: "ap-northeast-1",
    accessKeyId: "AKIAZWUEDIZHWHSYR5PU",
    secretAccessKey: "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"
  },
  GIT_HASH: '',
  GIT_BRANCH: '',
  SAML_ENABLE: false,
  IS_MAINTENANCE: false
}

export default config



// WEBPACK FOOTER //
// src/config/config.js